import { render, staticRenderFns } from "./suoritemerkinta-details.vue?vue&type=template&id=e1614470&scoped=true&"
import script from "./suoritemerkinta-details.vue?vue&type=script&lang=ts&"
export * from "./suoritemerkinta-details.vue?vue&type=script&lang=ts&"
import style0 from "./suoritemerkinta-details.vue?vue&type=style&index=0&id=e1614470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1614470",
  null
  
)

export default component.exports